import { useState } from 'react';
import { ALERT_STYLE, TOGGLEABLE_ALERT_KINDS } from '../config/alerts';
import { FLOOD_CATEGORY_INFO, LEGEND_GAUGE_CATEGORIES } from '../config/gauges';
import { AlertGlyph, GaugeDot } from './AlertGlyph';

/**
 * FloodLegendView: collapsed shows six gauge dots and five alert icons with
 * captions; tapping expands to labelled rows.
 */
export function Legend() {
  const [expanded, setExpanded] = useState(false);
  return (
    <button
      type="button"
      className={`legend ${expanded ? 'is-expanded' : ''}`}
      onClick={() => setExpanded((e) => !e)}
      aria-expanded={expanded}
      aria-label={expanded ? 'Collapse legend' : 'Expand legend'}
    >
      <div className="legend-header">
        <svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3V6z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        </svg>
        <span>Legend</span>
        <span className="legend-chevron" aria-hidden="true">▾</span>
      </div>

      {expanded ? (
        <>
          <div className="legend-section-label">River Gauges</div>
          <div className="legend-rows">
            {LEGEND_GAUGE_CATEGORIES.map((c) => (
              <div key={c} className="legend-row">
                <GaugeDot color={FLOOD_CATEGORY_INFO[c].color} />
                <span>{c === 'unknown' ? 'Unknown State' : FLOOD_CATEGORY_INFO[c].label}</span>
              </div>
            ))}
          </div>
          <hr className="legend-divider" />
          <div className="legend-section-label">Flood Alerts</div>
          <div className="legend-rows">
            {TOGGLEABLE_ALERT_KINDS.map((k) => (
              <div key={k} className="legend-row">
                <AlertGlyph kind={k} size={22} animated={ALERT_STYLE[k].shape === 'triangle'} />
                <span>{ALERT_STYLE[k].label}</span>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <div className="legend-strip">
            {LEGEND_GAUGE_CATEGORIES.map((c) => (
              <GaugeDot key={c} color={FLOOD_CATEGORY_INFO[c].color} size={16} />
            ))}
          </div>
          <div className="legend-caption">River Gauges</div>
          <hr className="legend-divider" />
          <div className="legend-strip">
            {TOGGLEABLE_ALERT_KINDS.map((k) => (
              <AlertGlyph key={k} kind={k} size={20} />
            ))}
          </div>
          <div className="legend-caption">NWS Alerts</div>
        </>
      )}
    </button>
  );
}
